export default __webpack_public_path__ + "static/media/g1.4489e4b6.png";